export default __webpack_public_path__ + "static/course-logo-pps-2eb0d2fd61e89f6b58287d7cf8dd4a16.jpg";